module.exports = "/public/images/d9e0fcab324d6f604b63da31567e6a95.svg";